import { ref } from "vue";
import { Attribute } from "@/services/things/models";
import { registriesAPI, SavedRegistrySchema } from "@/services/registries/registriesAPI";
import { withLoadingScreen } from "@/lib/loading";

export function useSchemaAttributeForm() {
    const allRegistrySchemas = ref<SavedRegistrySchema[]>([]);
    const editAttribute = ref<Attribute>();
    const editAttributeFormVisible = ref(false);
    const isNewAttribute = ref(false);

    function showAddAttributeForm() {
        editAttributeFormVisible.value = true;
        isNewAttribute.value = true;
        editAttribute.value = {
            name: "",
            display_name: "",
            display_order: 0,
            type: "string",
            widget_type: "textarea",
            required: false,
            hidden: false,
            editable: true,
            automated: false,
            option_default: null,
        };
    }

    function showEditAttributeForm(attribute: Attribute) {
        editAttribute.value = attribute;
        editAttributeFormVisible.value = true;
    }

    function closeEditAttributeForm() {
        editAttribute.value = undefined;
        editAttributeFormVisible.value = false;
        isNewAttribute.value = false;
    }

    async function initialize() {
        await withLoadingScreen(async () => {
            allRegistrySchemas.value = await registriesAPI.fetchAllRegistrySchemas();
        });
    }

    return {
        allRegistrySchemas,
        editAttribute,
        editAttributeFormVisible,
        isNewAttribute,
        showAddAttributeForm,
        showEditAttributeForm,
        closeEditAttributeForm,
        initialize,
    };
}
